module.exports = __webpack_public_path__ + "static/media/HT.a7710af7.png";